import { useState } from "react"
import { Button, Col, OverlayTrigger, Row, Spinner, Tab, Tabs, Tooltip } from "react-bootstrap"
import data from '../../lib/backend/data'
import { toast } from 'react-toastify';
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useDispatch, useSelector } from "react-redux";
import { cerrarSesion } from "../../redux/actions/session";
import { nombreDNIPorPais } from "../../lib/helpers/data/internationa";
import CamposObligatoriosLeyenda from "../general/campos_obligatorios";
import DestinatariosBodegasListado from "./destinatarios_bodegas/list";
import DestinatariosContactosListado from "./destinatarios_contactos/list";
import CamposPersonalizadosRelacionador from "../general/campos_personalizados_relacionador";

const DetailFull = (props) => {
    const [proveedor, setProveedor] = useState(props.proveedor ? props.proveedor : false)
    const [loading, setLoading] = useState(false)
    const [removiendo, setRemoviendo] = useState(false)
    const [nuevoProveedor, setNuevoProveedor] = useState({})
    const session = useSelector(state => state.miusuario)
    const pais = useSelector(state => state.pais)
    const token = session.tokenSession
    const [crear, setCrear] = useState(props.crear ? props.crear : false)
    const dispatch = useDispatch()

    const handleChange = (e) => {
        const { name, value } = e.target
        proveedor[name] = value
        return setProveedor(proveedor)
    }

    const crearNuevo = async () => {
        const requeridos = [
            { value:'razon_social', label: 'Nombre o razón social'},
            { value: "tipo", label: "Tipo" },
        ]
        let faltantes = []
        requeridos.map(campo => {
            if(!nuevoProveedor[campo.value]) faltantes.push(campo.label)
            return true
        })
        if(faltantes.length > 0) return toast.error(`Faltan campos: ${faltantes.join(', ')}`)
        setLoading(true)
        return fetch(`${data.urlapi}/destinatarios`, {
            method: 'POST',
            body: JSON.stringify(nuevoProveedor),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
          })
          .then(pros => pros.json())
          .then(async pros => {
              if(!pros){
                    toast.error('Hubo un error de servidor', this.state.toaststyle)
                    return this.setState({ loadingFormulario: false })
              } else if(pros.errorMessage){
                    toast.error(pros.errorMessage, this.state.toaststyle)
                    return this.setState({ loadingFormulario: false })
              } else if(pros._id){
                    if(props.onProveedorNuevo) props.onProveedorNuevo(pros)
                    toast.success(`Realizado exitosamente`)
                    setNuevoProveedor({...{}, ...{}})
              }
              return setLoading(false)
          })
          .catch(async error => {
                toast.error('No se pudo actualizar el registro')
                return setLoading(false)
          })
    }

    const guardarCambios = async () => {
        setLoading(true)
        return fetch(`${data.urlapi}/destinatarios`, {
            method: 'PUT',
            body: JSON.stringify(proveedor),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
          })
          .then(pros => pros.json())
          .then(async pros => {
              if(!pros){
                toast.error('Hubo un error de servidor', this.state.toaststyle)
                return this.setState({ loadingFormulario: false })
              } else if(pros.errorMessage){
                toast.error(pros.errorMessage, this.state.toaststyle)
                return this.setState({ loadingFormulario: false })
              } else if(pros._id){
                  if(props.onProveedorGuardado) props.onProveedorGuardado(proveedor)
                  toast.success(`Realizado exitosamente`)
              }
              return setLoading(false)
          })
          .catch(async error => {
                toast.error('No se pudo actualizar el registro')
                return setLoading(false)
          })
    }

    const handleChangeNuevo = (e) => {
        const { name, value } = e.target
        nuevoProveedor[name] = value
        return setNuevoProveedor(nuevoProveedor)
    }

    const formularioNuevo = () => {
        return <div>
            <Row>
                <Col md={12}>
                    <h4>Crear nuevo cliente</h4>
                    <p>Crea los clientes con los que trabajas y mantén centralizada la operación de cada uno, de esta forma podrás compartir información.</p>
                    <CamposObligatoriosLeyenda />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">Nombre o razón social</label>
                    <input className="form-control" name="razon_social" value={nuevoProveedor.razon_social} onChange={handleChangeNuevo} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">Tipo</label>
                    <select className="form-control" name="tipo" value={nuevoProveedor.tipo} onChange={handleChangeNuevo} >
                        <option value="">Seleccione</option>
                        <option value="persona">Persona</option>
                        <option value="empresa">Empresa</option>
                    </select>
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">{nombreDNIPorPais(pais)}</label>
                    <input className="form-control" name="rut" value={nuevoProveedor.rut} onChange={handleChangeNuevo} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">Dirección principal</label>
                    <input className="form-control" name="direccion" value={nuevoProveedor.direccion} onChange={handleChangeNuevo} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">Teléfono fijo</label>
                    <input className="form-control" name="telefono" value={nuevoProveedor.telefono} onChange={handleChangeNuevo} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">Teléfono móvil</label>
                    <input className="form-control" name="movil" value={nuevoProveedor.movil} onChange={handleChangeNuevo} />
                </Col>
                <Col md={12}>
                    {
                        loading === true ? <Spinner animation="border" /> : <Button size="sm" variant="success" onClick={()=>crearNuevo()} >CREAR NUEVO</Button>
                    }
                </Col>
            </Row>
        </div>
    }

    const confirmarEliminado = async (id) => {
        setRemoviendo(true)
        return fetch(`${data.urlapi}/destinatarios?id=${id}`,{
            method:'DELETE',
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            console.log(res)
            if(!res){
                toast.error('Sin datos')
                return setRemoviendo(false)
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return setRemoviendo(false)
            } else if(res._id){
                if(props.onFieldDeleted) props.onFieldDeleted(res._id)
            }
            setProveedor(false)
            setCrear(true)
            return setRemoviendo(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            return setRemoviendo(false)
        })
    }

    const solicitarEliminar = (id) => {
        return confirmAlert({
            title: `¿Estás seguro?`,
            message: `Confirma que deseas eliminar definitivamente este registro, esta acción no se puede deshacer`,
            buttons: [
              {
                label: 'CONFIRMAR',
                onClick: () => confirmarEliminado(id)
              },
              {
                label: 'CANCELAR',
                onClick: () => false
              }
            ]
          })
    }

    const View = () => {
        if(!proveedor) return formularioNuevo()
        return <div>
            <h4 className="mb-0">Detalles del cliente <b>{proveedor.razon_social}</b></h4>
            {
                removiendo === true ? <Spinner animation="border" /> : <Button variant="link" className="text-danger p-0 d-block mb-3" onClick={()=>solicitarEliminar(proveedor._id)} >Eliminar</Button>
            }
            <Tabs defaultActiveKey="editar" >
            <Tab eventKey="editar" className="mt-4" title="Ficha informativa ">
                <Row>
                <Col className="mb-3">
            <OverlayTrigger
                            placement={'top'}
                            overlay={
                              <Tooltip>Esta es la forma en que debes escribirlo en el documento excel de importación o API</Tooltip>
                            }
                            >
                                <h5 style={{ backgroundColor: '#c7c7c7', borderRadius: 5, color: 'white', fontSize: 13, display: 'inline', padding: '3px 5px' }}><b style={{ color:'black' }}>SLUG </b> { proveedor.razon_social ? proveedor.razon_social.toLowerCase().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'').normalize("NFD").replace(/[\u0300-\u036f]/g, "") : '' }</h5>
                          </OverlayTrigger>
        </Col>
        <Col md={12} className="mb-3">
            <label className="form-control-label d-block">Nombre o razón social</label>
            <input className="form-control" name="razon_social" defaultValue={proveedor.razon_social} onChange={handleChange} />
        </Col>
        <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">Tipo</label>
                    <select className="form-control" name="tipo" value={proveedor.tipo} onChange={handleChange} >
                        <option value="">Seleccione</option>
                        <option value="persona">Persona</option>
                        <option value="empresa">Empresa</option>
                    </select>
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">{nombreDNIPorPais(pais)}</label>
                    <input className="form-control" name="rut" value={proveedor.rut} onChange={handleChange} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">Dirección principal</label>
                    <input className="form-control" name="direccion" value={proveedor.direccion} onChange={handleChange} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">Teléfono fijo</label>
                    <input className="form-control" name="telefono" value={proveedor.telefono} onChange={handleChange} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block">Teléfono móvil</label>
                    <input className="form-control" name="movil" value={proveedor.movil} onChange={handleChange} />
                </Col>
        <Col md={12}>
            <CamposPersonalizadosRelacionador id_target={proveedor._id} condicion_default={{ module: "destinatarios" }}  />
            {
                loading === true ? <Spinner animation="border" /> : <Button size="sm" variant="success" onClick={()=>guardarCambios()} >GUARDAR CAMBIOS</Button>
            }
        </Col>
        </Row>
            </Tab>
            <Tab eventKey="bodegas" className="mt-4" title="Bodegas" >
                <DestinatariosBodegasListado id_cliente={proveedor._id} condicion_default={{ id_cliente: proveedor._id }} />
            </Tab>
            <Tab eventKey="contactos" className="mt-4" title="Contactos" >
                <DestinatariosContactosListado id_cliente={proveedor._id} condicion_default={{ id_cliente: proveedor._id }} />
            </Tab>
        </Tabs>
        </div>
    }

    return <div>
        {View()}
    </div>
}

export default DetailFull